<template>
  <vs-popup
    class="holamundo"
    :title="title"
    :active.sync="addNewDataLocal"
    @vs-close="closeForm">
    <form @submit.prevent>
      <vs-input label="Name" name="name" v-model="name" class="mt-5 w-full" />
    </form>
    <vs-divider />
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
          @click="submitForm"
          v-if="!editMode"
          >Submit
        </vs-button>
        <vs-button
          class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
          @click="updateForm"
          v-if="editMode"
          >Update
        </vs-button>
        <vs-button
          color="danger"
          class="mr-3 mb-2 btn-load-3 vs-con-loading__container"
          @click="deleteData"
          v-if="editMode"
          >Delete
        </vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="closeForm"
          >Cancel</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  watch: {
    editMode(val) {
      if (val) {
        this.name = this.dataEdit.alert_name
        //
      } else {
        //
      }
    },
  },
  mounted() {
    //
  },
  computed: {
    addNewDataLocal: {
      get() {
        if (this.addNewData && this.editMode) {
          //
          this.name = this.dataEdit.alert_name
        }
        return JSON.parse(this.addNewData)
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      parent_array: [],
      name: '',
    }
  },
  methods: {
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.name = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1')
      let dataForm = {
        alert_name: this.name,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.postAlert(dataForm)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-1')
          this.$emit('submitModal', false)
          this.$toast.success('Data Successfully Submitted')
        })
        .catch((err) => {
          this.loadingBtnStop('btn-load-1')
          //
          this.$toast.error(err.message)
        })
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3')
      REPO.deleteAlert(this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-3')
          this.$emit('submitModal', false)
          this.$toast.error('Data Successfully Deleted')
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-3')
          this.$toast.error(err.message)
        })
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2')
      let dataForm = {
        alert_name: this.name,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.updateAlert(dataForm, this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-2')
          this.$emit('submitModal', false)
          this.$toast.success('Data Successfully Submitted')
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-2')
          this.$toast.error(err.message)
        })
    },
  },
}
</script>
<style>
sup {
  color: red;
}
</style>
